import React, { useContext, useEffect, useState } from "react";
import CustomTable from "../../table/CustomTable";
import CustomWrapper from "../../wrapper/CustomWrapper";
import SVGProgress from "../../svg_progress/SVGProgress";
import "./PaymentDashboard.css";
import Graph from "../../Graph/Graph";
import { getAllTrancationsForPropertyManager, getPaymentMethodForUser, pmTransactionInsite } from "../../../services/payment.method.service";
import { isLoggedIn } from "../../../utility/util";
import { Link } from "react-router-dom";

import SidePopupWrapper from "../../wrapper/SidePopupWrapper";
import { MdClose } from "react-icons/md";
import { getAllProperties, getDuesForPM } from "../../../services/property.service";
import { Loader, MiniLoader } from "../../Loader/Loader";
import NoDataFound from "../../NoDataFoundWidget/NoDataFound";

function PaymentDashboard({ userData = null, graphDuration = 6, onNoPaymentAccountFound = null }) {
  const [isLoading, setLoading] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const [isOutstandingPayments, setIsOutstandingPayments] = useState(false);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [customTableData, setCustomTableData] = useState([]);
  const [graphDetails, setGraphDetails] = useState(null);
  const [balanceRenters, setBalanceRenter] = useState([]);
  const [totalRenters, setTotalRenters] = useState(0);
  const [totalProperties, setTotalProperties] = useState(0);
  const [currentMonthOntime, setCurrentMonthOntime] = useState(0);

  useEffect(() => {
    document.title = "Payment Details | Property Manager | Ando";
    let uInfo = isLoggedIn();

    let currentDate = new Date();
    let renterConfirmedDate = new Date();
    let totalRentFromStart = 0;
    let totalRentPerMonthExpected = 0;
    let tempExpectedRent = 0;
    let insiteData = null;

    if (userData == null) {
      userData = uInfo;
    }
    setLoading(true);
    getDuesForPM(uInfo?.data?.id)
      .then((resp) => {
        if (resp?.length > 0) {
          let allProperties = [];
          let allRenters = [];
          let balanceRenters = [];
          let totalPendingRent = 0;
          resp?.map((renter, j) => {
            renter?.map((item, i) => {
              if (!allProperties?.includes(item?.address))
                allProperties.push(item?.address)
              if (!allRenters?.includes(item?.propertyName))
                allRenters.push(item?.propertyName)
              let currentDate = new Date();
              let date = new Date(`${item?.year}-${String(item?.month).padStart(2, "0")}-01`)
              balanceRenters.push(
                <BalanceRenter
                  date={date.toLocaleString("default", { month: "long" }) + " " + date.getFullYear()}
                  tenant={item?.renterName}
                  tenantEmail={item?.renterEmail}
                  address={item.address}
                  unit={item.propertyName}
                  amount={item?.rent + ((i == 0) && (currentDate?.getDate() < 16) ? 0 : item?.penalty)}
                  key={`${j}_${i}`}
                />)
              totalPendingRent += (item?.rent + ((i == 0) && (currentDate?.getDate() < 16) ? 0 : item?.penalty))
            })
          })
          setLoading(false);
          setPendingAmount(totalPendingRent)
          setTotalProperties(allProperties?.length);
          setTotalRenters(allRenters  ?.length)
          setBalanceRenter(balanceRenters)
        }
      })
    setLoading(true);
    getPaymentMethodForUser(uInfo?.data?.id).then((resp) => {
      pmTransactionInsite(uInfo.data.id, graphDuration)
        .then((resp) => {
          setLoading(false);
          if (resp?.status) {
            tempExpectedRent = resp?.data?.perMonthExpectedRent;
            let totalOntimeCount = resp?.data?.ontimePayments?.data?.reduce((acc, item) => (acc + parseInt(item?.on_time_payments ?? 0)), 0);
            let totalExpectedCount = resp?.data?.ontimePayments?.data?.reduce((acc, item) => (acc + parseInt(item?.total_expected_transaction ?? 0)), 0);
            let res = totalExpectedCount == 0 && totalOntimeCount != 0 ? 100 : totalExpectedCount == 0 ? 0 : Math.round((totalOntimeCount / totalExpectedCount) * 100)
            let temp = isNaN(res) ? 0 : res
            setCurrentMonthOntime(temp > 100 ? 100 : temp)
            insiteData = resp;
          }
        })
        .finally(() => {
          setLoading(true);
          getAllProperties(uInfo?.data?.id)
            .then((properties) => {
              setLoading(false);
              if (properties.length > 0) {
                let renters = 0;
                properties.forEach((property) => {
                  property.units.forEach((unit) => {
                    if (unit.renterDetails.confirmed) {
                      renters++;
                      renterConfirmedDate = new Date(unit.renterConfirmedDate);
                      let diffDate = currentDate - renterConfirmedDate;
                      let totalMonths = Math.floor(diffDate / 1000 / 60 / 60 / 24 / 30) + 2;
                      totalRentFromStart += (parseInt(unit.rentalPrice) * totalMonths);
                      totalRentPerMonthExpected += parseInt(unit.rentalPrice);
                    }
                  })
                })
              }
            })
            .then(() => {
              setLoading(true);
              getAllTrancationsForPropertyManager(uInfo?.data?.id, 24).then((transactions) => {
                setLoading(false);
                if (!resp?.status && !transactions.status && totalProperties == 0) {
                  onNoPaymentAccountFound();

                  setGraphDetails("");
                }
                else if (!transactions.status) {
                  let emptyGraphData = [];
                  const now = new Date();
                  const numMonths = graphDuration === 'current' ? 1 : parseInt(graphDuration);
                  for (let i = 0; i < numMonths; i++) {
                    let d = new Date(now.getFullYear(), now.getMonth() - i, 1);
                    let month = d.toLocaleString("default", { month: "long" });
                    let year = d.getFullYear();
                    let insite = insiteData?.data?.rentForPastMonths?.find((e) => {
                      let tempDate = new Date(`${e?.month_start} 00:00:00`);
                      return tempDate?.getFullYear() == year && tempDate?.toLocaleString("default", { month: "long" }) == month;
                    });
                    emptyGraphData.push({
                      month, year, paymentReceived: 0,
                      expectedRent: parseInt(insite?.expectedRent ?? 0)
                    });
                  }
                  setGraphDetails({
                    dataName: "Rent Collected",
                    total: 0,
                    max_monthly_payment_expected: totalRentPerMonthExpected == 0 ? parseInt(tempExpectedRent) : totalRentPerMonthExpected,
                    data: emptyGraphData
                  });
                }
                else {
                  let graphData = [];
                  let onTimeTransactions = 0;
                  let customData = [];
                  let balance = 0;
                  let totalRentPaid = 0;
                  transactions.data?.forEach((element) => {
                    balance += element.transactionDetails.balance;
                    totalRentPaid += parseFloat(element.rentAmount);
                    let paymentDate = new Date(element.created_at);
                    if (element.transactionDetails.balance <= 0) {
                      onTimeTransactions++;
                    }
                    let rentFor = new Date(`16 ${element?.transactionDetails?.rentPeriod}`)
                    let paymentStatus = paymentDate > rentFor ? "Late" : "On Time";
                    let graphPaymentDate = new Date(`01 ${element?.transactionDetails?.rentPeriod} 00:00:00`);
                    let graphMonth = graphPaymentDate.toLocaleString("default", { month: "long" });
                    let graphYear = graphPaymentDate.getFullYear();
                    let graphAmount = parseFloat(element.rentAmount);
                    let currentDataIndex = graphData.findIndex((e) => e?.month === graphMonth && e?.year === graphYear)
                    let insite = insiteData?.data?.rentForPastMonths?.find((e) => {
                      let tempDate = new Date(`${e?.month_start} 00:00:00`);
                      return tempDate?.getFullYear() == graphYear && tempDate?.toLocaleString("default", { month: "long" }) == graphMonth
                    })
                    if (currentDataIndex !== -1) {
                      graphData[currentDataIndex].paymentReceived += graphAmount
                    }
                    else {
                      graphData.push({
                        month: graphMonth,
                        year: graphYear,
                        paymentReceived: graphAmount,
                        expectedRent: parseInt(insite?.expectedRent ?? 0) ?? 0
                      })
                    }

                    if (!element?.id?.toString().includes(".")) {
                      let data = {
                        "Property/Unit": <div className="tablePropertyColumn">
                          {element.transactionDetails.property_details.address}
                          <p>#{element.transactionDetails.property_details.unit}</p>
                        </div>,
                        "Tenant": <div className="tableRenterColumn">
                          {element.transactionDetails.renter.name}
                          <p>{element.transactionDetails.renter.email}</p>
                        </div>,
                        "Amount": "$" + (element.rentAmount != null ? parseFloat(element.rentAmount).toFixed(2) : parseFloat(element.totalAmount ?? 0).toFixed(2)),
                        "Status": paymentStatus,
                        "Balance": "$" + element.transactionDetails.balance,
                        "Payment Date": `${paymentDate.getDate()} ${paymentDate.toLocaleString("default", { month: "long" })}, ${paymentDate.getFullYear()}`,
                        "Rent Period": `${element.transactionDetails?.rentPeriod}`,
                      }
                      customData.push(data)
                    }
                  })

                  // Fill in missing months for the graph duration
                  const now = new Date();
                  const numMonths = graphDuration === 'current' ? 1 : parseInt(graphDuration);
                  for (let i = 0; i < numMonths; i++) {
                    let d = new Date(now.getFullYear(), now.getMonth() - i, 1);
                    let gMonth = d.toLocaleString("default", { month: "long" });
                    let gYear = d.getFullYear();
                    if (!graphData.find(e => e.month === gMonth && e.year === gYear)) {
                      let insite = insiteData?.data?.rentForPastMonths?.find((e) => {
                        let tempDate = new Date(`${e?.month_start} 00:00:00`);
                        return tempDate?.getFullYear() == gYear && tempDate?.toLocaleString("default", { month: "long" }) == gMonth;
                      });
                      graphData.push({
                        month: gMonth, year: gYear, paymentReceived: 0,
                        expectedRent: parseInt(insite?.expectedRent ?? 0)
                      });
                    }
                  }

                  setGraphDetails(...[{
                    dataName: "Rent Collected",
                    total: totalRentPaid,
                    max_monthly_payment_expected: totalRentPerMonthExpected == 0 ? parseInt(tempExpectedRent) : totalRentPerMonthExpected,
                    data: graphData
                  }])
                  setCustomTableData([...customData]);
                }
              })
                .catch((e) => {
                  setGraphDetails("");
                })
            })
        })
    });
  }, [graphDuration]);
  const performPoPup = (called) => {
    setIsOutstandingPayments(called);
  };
  const onClose = () => {
    setIsOutstandingPayments(false);
  }

  if (noDataFound) {
    return (
      <CustomWrapper
        width="auto"
        maxWidth={"auto"}
        height="100%"
        marginHorizontal="50px"
        marginVertical="10px"
        paddingHorizontal={30}
        paddingVertical={30}
      >
        <div className="paymentOptionContainer">
          <div className="manageAccountHeader">
            <div className="title">Payment Transactions</div>
          </div>
          <div className="renterDescription">
            Come back here for a detailed transaction log of all rent payments
            once you've successfully collected your first one
          </div>
        </div>
      </CustomWrapper>
    );
  } else {
    return (
      <div style={{
        height: '100%',
        paddingBottom: 80
      }}>
        <CustomWrapper
          width="auto"
          maxWidth={"auto"}
          height="100%"
          marginHorizontal="50px"
          marginVertical="10px"
          paddingHorizontal={30}
          paddingVertical={30}
          background="transparent"
          border="none"
        >
          <div className="paymentDashboard">
            <div className="topDivContainer">
              <div className="leftDiv">
                <div className="subDash subRow">
                  {
                    customTableData.length > 0 ?
                      <>
                        <div className="infoDiv">
                          <div className="subDashTitle">On-Time Payments</div>
                          <div className="subDashDesc">
                            Percentages of payments made before or by the expected rent
                            due date
                          </div>
                        </div>
                        <SVGProgress _percentage={currentMonthOntime} />
                      </>
                      :
                      <>
                        <div className="infoDiv">
                          <div className="subDashTitle">On-Time Payments</div>
                          <NoDataFound message="Data will appear once rent has been collected.." />
                        </div>
                      </>
                  }
                </div>
                <div className="subDash subColumn">
                  {
                    customTableData.length > 0 ?
                    <>
                      <div className="infoDiv">
                        <div className="subDashTitle">Outstanding Payments</div>
                        <div className="subDashDesc">Rental payments still owed</div>
                      </div>
                      <div className="pendingRentHint">{isLoading ? <MiniLoader /> : `$${pendingAmount}`}</div>
                      <div className="viewOutstanding">
                        <Link onClick={performPoPup}> view Details &gt; </Link>
                      </div>
                    </>
                    :
                    <>
                      <div className="infoDiv">
                        <div className="subDashTitle">On-Time Payments</div>
                        <NoDataFound message="Data will appear once rent has been collected.." />
                      </div>
                    </>
                  }
                </div>
              </div>
              <div className="rightDiv">
                <Graph
                  showGraph={(graphDetails != null && graphDetails != "")}
                  json={graphDetails}
                  graphDuration={graphDuration}
                />
                {
                  graphDetails == null &&
                  <div className='graphContainer' style={{
                    height: '100%',
                    background: "#FFFFFF",
                    borderRadius: 10,
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}><MiniLoader /> </div>
                }
              </div>
            </div>
            <CustomTable
              title={"Payment Transactions"}
              json={customTableData}
              showTable={customTableData.length > 0}
            />
          </div>
        </CustomWrapper>
        {isOutstandingPayments && (
          <SidePopupWrapper>
            <div className="paymentHeader">
              <MdClose
                onClick={onClose}
                color="white"
                size={20}
                className="closePopup "
              />
              <label>Outstanding Payments</label>
            </div>
            <div className="paymentBody" style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <div className="owe-container">
                <div className="bodyTitle"> You’re owed</div>
                <div className="pendingRentHint owe-amount">${pendingAmount}</div>
              </div>
              <div className="detailsContainer">
                <div className="details">
                  <div className="countTenants">{totalRenters}</div>
                  <div className="tenants">tenants</div>
                </div>
                <div className="details">
                  <div className="countTenants">{totalProperties}</div>
                  <div className="tenants">properties</div>
                </div>
              </div>
              <hr className="hr2" />
              <div style={{ width: "100%", overflowY: "auto", flex: 1 }} className="scroller">
                {balanceRenters}
              </div>
            </div>
            <div className="paymentFooter"></div>
          </SidePopupWrapper>
        )}
        {
          isLoading && <Loader />
        }
      </div>
    );
  }
}

const BalanceRenter = ({
  address, unit, tenant, tenantEmail, amount, date
}) => {
  return (
    <>
      <div className="grid-container">
        <div className="grid-item">
          <b>{address}</b>
          <span>{unit}</span>
        </div>
        <div className="grid-item">
          <b>{tenant}</b>
          <span className="disabled">{tenantEmail}</span>
        </div>
        <div className="grid-item">
          <b>${amount}</b>
          <span className="disabled">{date}</span>
        </div>
      </div>
      <hr />
    </>
  )
}
export default PaymentDashboard;
